import React, { useState } from 'react';
import './Contact.css';
import emailjs from 'emailjs-com';

const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
const validatePhone = (phone) => phone === '' || /^\+?[\d\s-()]{7,}$/.test(phone);

const Contact = () => {
  const [values, setValues] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [touched, setTouched] = useState({
    name: false,
    email: false,
    phone: false,
    message: false,
  });

  const errors = {
    name: values.name.trim() === '' ? 'Name is required' : '',
    email:
      values.email.trim() === ''
        ? 'Email is required'
        : !validateEmail(values.email)
        ? 'Enter a valid email address'
        : '',
    phone: !validatePhone(values.phone) ? 'Enter a valid phone number' : '',
    message: values.message.trim() === '' ? 'Message is required' : '',
  };

  const isFormValid = Object.values(errors).every((e) => e === '');

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleBlur = (e) => {
    setTouched({ ...touched, [e.target.name]: true });
  };

  function sendEmail(e) {
    e.preventDefault();
    if (!isFormValid) return;

    emailjs
      .sendForm(
        'service_5qn6xkx',
        'template_m8uabev',
        e.target,
        'user_xYaO9EkNJILhj1KEfoHGO'
      )
      .then(
        (result) => {
          console.log(result.text);
          document.getElementById('successMessage').innerHTML =
            'Your message has been submitted successfully.';
          setTimeout(function () {
            document.getElementById('successMessage').innerHTML = '';
          }, 4000);
        },
        (error) => {
          console.log(error.text);
          document.getElementById('errorMessage').innerHTML = error.text;
          setTimeout(function () {
            document.getElementById('errorMessage').innerHTML = '';
          }, 4000);
        }
      );
    e.target.reset();
    setValues({ name: '', email: '', phone: '', message: '' });
    setTouched({ name: false, email: false, phone: false, message: false });
  }

  return (
    <div id='contact'>
      <div className='container'>
        <h1 className='section-title'>Contact</h1>
        <div className='contact-form'>
          <form onSubmit={sendEmail}>
            <div className='form-floating mb-3'>
              <input
                type='text'
                className='form-control'
                id='floatingName'
                name='name'
                placeholder='Name'
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
              ></input>
              <label htmlFor='floatingName'>Name</label>
              {touched.name && errors.name && (
                <div className='invalid-feedback d-block'>{errors.name}</div>
              )}
            </div>
            <div className='form-floating mb-3'>
              <input
                type='email'
                className='form-control'
                id='floatingEmail'
                name='email'
                placeholder='Email address'
                value={values.email}
                onChange={handleChange}
                onBlur={handleBlur}
              ></input>
              <label htmlFor='floatingEmail'>Email address</label>
              {touched.email && errors.email && (
                <div className='invalid-feedback d-block'>{errors.email}</div>
              )}
            </div>
            <div className='form-floating mb-3'>
              <input
                type='tel'
                className='form-control'
                id='floatingPhone'
                name='phone'
                placeholder='Phone Number'
                value={values.phone}
                onChange={handleChange}
                onBlur={handleBlur}
              ></input>
              <label htmlFor='floatingPhone'>Phone Number</label>
              {touched.phone && errors.phone && (
                <div className='invalid-feedback d-block'>{errors.phone}</div>
              )}
            </div>
            <div className='form-floating'>
              <textarea
                className='form-control'
                placeholder='Message'
                id='floatingMessage'
                name='message'
                style={{ height: 100 }}
                value={values.message}
                onChange={handleChange}
                onBlur={handleBlur}
              ></textarea>
              <label htmlFor='floatingMessage'>Message / Query </label>
              {touched.message && errors.message && (
                <div className='invalid-feedback d-block'>{errors.message}</div>
              )}
            </div>
            <div className='d-grid gap-2 mt-3'>
              <button
                className='btn form-submit-button'
                type='submit'
                value='Send'
                disabled={!isFormValid}
              >
                Submit
              </button>
            </div>
          </form>
          <div className='mt-3'>
            <p id='successMessage' className='text-center'></p>
            <p id='errorMessage' className='text-danger text-center'></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
